import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { SelectedFiltersList, SelectedFiltersText } from './'

class SelectedFilters extends Component {
  render () {
    const {
      filterSelected,
      categories,
      handleFilterChanged
    } = this.props

    return (
      <div className='container-filter container-selected-filter row radius border-none radius mb-1'>
        <div className='filter-accordion filtered-accordion col-12 px-0'>
          <div className='panel-selected pl-1 px-md-2 pt-0 pt-md-2 row'>
            <SelectedFiltersText filterSelected={filterSelected} handleFilterChanged={handleFilterChanged} />
            <SelectedFiltersList filterSelected={filterSelected} handleFilterChanged={handleFilterChanged} listObject={categories} />
          </div>
        </div>
      </div>
    )
  }
}
SelectedFilters.propTypes = {
  filterSelected: PropTypes.object,
  categories: PropTypes.array,
  handleFilterChanged: PropTypes.func.isRequired
}

export default SelectedFilters



// WEBPACK FOOTER //
// ./src/features/MeuBairro/Filters/SelectedFilters.js